import { useCallback } from 'react';
import * as Cesium from 'cesium';

export function useOrbitTiming(
  orbitLeadTimeRef: React.MutableRefObject<number>,
  orbitTrailTimeRef: React.MutableRefObject<number>,
  viewerRef: React.MutableRefObject<Cesium.Viewer | null>,
  secondaryViewerRef: React.MutableRefObject<Cesium.Viewer | null>,
) {
  const setOrbitLeadTime = useCallback((sec: number) => {
    orbitLeadTimeRef.current = sec;
    // Force Cesium to re-evaluate path CallbackProperties on next frame
    const v = viewerRef.current;
    if (v) v.scene.requestRender();
    const sv = secondaryViewerRef.current;
    if (sv) sv.scene.requestRender();
  }, []);

  const setOrbitTrailTime = useCallback((sec: number) => {
    orbitTrailTimeRef.current = sec;
    const v = viewerRef.current;
    if (v) v.scene.requestRender();
    const sv = secondaryViewerRef.current;
    if (sv) sv.scene.requestRender();
  }, []);

  return {
    setOrbitLeadTime,
    setOrbitTrailTime,
  };
}
